// CSS Modules - component class name prefix: ResultTeaser__

<template>
  <figure :class="$style.container">
    <template v-if="isVideo">
      <a
        v-if="result._source.image"
        :class="$style.imageLink"
        @click="
          handleTracking($event);
          isModalOpen = true;
        "
      >
        <div
          :class="$style.bgImage"
          :style="{ backgroundImage: `url(${result._source.image})` }"
        >
          <img :src="result._source.image" :alt="result._source.title" />
          <i
            v-if="result._source.archived"
            :class="['fa fa-archive', $style.archived]"
          />
        </div>
      </a>
      <figcaption>
        <a
          :class="$style.textLink"
          @click="
            handleTracking($event);
            isModalOpen = true;
          "
        >
          <div
            v-if="result._source.breadcrumb"
            :class="$style.path"
            v-html="`${result._source.breadcrumb.replace(/\,/g, ' > ')}`"
          ></div>
          <div v-else :class="$style.path">
            {{ result._source.categorylabel }}
          </div>
          <h3 v-html="getTitleWithMaxLength(result)"></h3>
          <div v-if="result.highlight && result.highlight.description">
            <span v-html="getDescriptionWithMaxLength(result)" />
          </div>
          <div :class="$style.url">{{ resultUrl }}</div>
        </a>
      </figcaption>
      <Modal
        :isModalOpen="isModalOpen"
        :isVideo="isVideo"
        @closeModal="isModalOpen = false"
      >
        <iframe
          :data-src="resultUrl + '?enablejsapi=1'"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </Modal>
    </template>
    <template v-else>
      <a
        v-if="result._source.image"
        :class="$style.imageLink"
        :href="setLinkUrl(resultUrl, this.terms)"
        :target="getLinkTarget()"
        @click="handleTracking"
      >
        <div
          :class="$style.bgImage"
          :style="{ backgroundImage: `url(${result._source.image})` }"
        >
          <img :src="result._source.image" :alt="result._source.title" />
          <i
            v-if="result._source.archived"
            :class="['fa fa-archive', $style.archived]"
          />
        </div>
      </a>
      <figcaption>
        <a
          :class="$style.textLink"
          :href="setLinkUrl(resultUrl, this.terms)"
          :target="getLinkTarget()"
          @click="handleTracking"
        >
          <div
            v-if="result._source.breadcrumb"
            :class="$style.path"
            v-html="`${result._source.breadcrumb.replace(/\,/g, ' > ')}`"
          ></div>
          <div v-else :class="$style.path">
            {{ result._source.categorylabel }}
          </div>
          <h3 v-html="getTitleWithMaxLength(result)"></h3>
          <div>
            <span v-html="getDescriptionWithMaxLength(result)" />
          </div>
          <div :class="$style.url">{{ resultUrl }}</div>
        </a>
      </figcaption>
    </template>
  </figure>
</template>

<script>
import truncate from "truncate-html";
import Modal from "../Modal/Modal.vue";
import { Category, DocType } from "../../globals/constants/search";
import { endsWith } from "../../utils/helper";

export default {
  name: "ResultTeaser",
  components: {
    Modal
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    webBaseUrl: {
      type: String,
      default: ""
    },
    shopBaseUrl: {
      type: String,
      default: ""
	},
	textfieldOfActivity: {
      type: String,
      default: ""
    },
	textLocation: {
      type: String,
      default: ""
    },
	textCountry: {
      type: String,
      default: ""
    },
	textTargetGroup: {
      type: String,
      default: ""
    },
	textEmployment: {
      type: String,
      default: ""
    },
	searchMicrosite: {
      type: Boolean,
      default: ""
    },
	terms: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resultUrl: "",
      isModalOpen: false,
      isVideo: false,
      wtTrack: window.wtTrack
    };
  },
  methods: {
    addDotsToLastElement(elem) {
      if (!elem || !elem.lastChild) {
        return;
      }

      if (
        elem.lastChild.nodeType === 3 &&
        elem.lastChild.nodeValue.trim() === ""
      ) {
        elem.removeChild(elem.lastChild);
      }

      const { lastChild } = elem;

      if (lastChild.nodeType === 1) {
        this.addDotsToLastElement(lastChild);
      } else if (lastChild) {
        if (!endsWith(lastChild.textContent.trim(), "...")) {
          const span = document.createElement("span");
          span.className = this.$style.dots;
          span.innerText = " ...";
          lastChild.parentNode.appendChild(span);
        }
      }
    },
    addTrailingDots(htmlString) {
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(htmlString, "text/html");
      this.addDotsToLastElement(parsedHtml.body);
      return parsedHtml.body.innerHTML;
    },
    handleTracking() {
      const wtParams = this.result._source.wtParams;
      wtParams && wtTrack({ cat: wtParams.doctype }, wtParams);
    },
    getLinkTarget() {
      return this.result._source.categoryuid === Category.DOWNLOAD ||
        this.result._source.docType === DocType.BLOG
        ? "_blank"
        : "_self";
    },
    getTitleWithMaxLength(result) {
      if(result._source.categoryuid === Category.JOBS)
	  {
		  if (result.highlight && result.highlight.position) {
			return result.highlight.position.join(" ");
		  } else if (result._source.position) {
			return result._source.position;
		  }
	  }
	  else
	  {
		  if (result.highlight && result.highlight.title) {
			return result.highlight.title.join(" ");
		  } else if (result._source.title) {
			return result._source.title;
		  }
	  }
    },
    getDescriptionWithMaxLength(result) {
      if(result._source.categoryuid === Category.JOBS)
	  {
		  var returnString = "";
		  if (result.highlight && result.highlight.fieldOfActivity) {
			returnString += this.textfieldOfActivity + ": " + result.highlight.fieldOfActivity.join(" ") + " - ";
		  } else if (result._source.fieldOfActivity) {
			returnString += this.textfieldOfActivity + ": " + result._source.fieldOfActivity + " - ";
		  }
		  if (result.highlight && result.highlight.location) {
			returnString += this.textLocation + ": " + result.highlight.location.join(" ") + " - ";
		  } else if (result._source.location) {
			returnString += this.textLocation + ": " + result._source.location + " - ";
		  }
		  if (result.highlight && result.highlight.country) {
			returnString += this.textCountry + ": " + result.highlight.country.join(" ") + " - ";
		  } else if (result._source.country) {
			returnString += this.textCountry + ": " + result._source.country + " - ";
		  }
		  if (result.highlight && result.highlight.targetGroup) {
			returnString += this.textTargetGroup + ": " + result.highlight.targetGroup.join(" ") + " - ";
		  } else if (result._source.targetGroup) {
			returnString += this.textTargetGroup + ": " + result._source.targetGroup + " - ";
		  }
		  if (result.highlight && result.highlight.employment) {
			returnString += this.textEmployment + ": " + result.highlight.employment.join(" ");
		  } else if (result._source.employment) {
			returnString += this.textEmployment + ": " + result._source.employment;
		  }
		  return returnString;
	  }
	  else
	  {
		  if (this.searchMicrosite)
		  {
			  if (result.highlight && result.highlight.contentUnstemmed) {
				return this.cropTextIfTooLong(result.highlight.contentUnstemmed.join(" "));
			  } else if (result._source.description) {
				return this.cropTextIfTooLong(result._source.description);
			  } else {
				return "";
			  }
		  }
		  else
		  {
			  if (result.highlight && result.highlight.description) {
				return this.cropTextIfTooLong(result.highlight.description.join(" "));
			  } else if (result._source.description) {
				return this.cropTextIfTooLong(result._source.description);
			  } else {
				return "";
			  }
		  }
	  }
    },
    cropTextIfTooLong(text) {
      const textWithoutParagraph = text
        .replace(/<p>/g, "")
        .replace(/<\/p>/g, "");

      if (this.result._source.categoryuid === "contacts") {
        return textWithoutParagraph.trim();
      }

      const description = truncate(textWithoutParagraph, 160, {
        ellipsis: "",
        reserveLastWord: true
      })
        .trim()
        .replace(/[\\.]{2,3}$/gm, "");

      return this.addTrailingDots(description);
    },
    setResultUrlWithOptionalPrefix(path, baseUrl) {
      if (path.indexOf("http") === 0) {
        this.resultUrl = this.result._source.path;
      } else {
        this.resultUrl = baseUrl + this.result._source.path;
      }
    },
	setLinkUrl(url, term) {
		let highlightString = "?highlightedText=" + term.slice(0, 1);
		if (url.indexOf('#') > -1)
		{
			let path = url.substring(0, url.indexOf("#"));
			let anchor = url.substring(url.indexOf("#"), url.length);
			return path + highlightString + anchor;
		}
		return url + highlightString;
	},
    preprocessResultCategory() {
      switch (this.result._source.categoryuid) {
        case Category.SHOP:
          this.setResultUrlWithOptionalPrefix(
            this.result._source.path,
            this.shopBaseUrl
          );
          break;
        case Category.VIDEOS:
          this.resultUrl = this.result._source.path;
          this.isVideo = true;
          break;
        case Category.BLOG:
          this.resultUrl = this.result._source.path;
          break;
        default:
          this.setResultUrlWithOptionalPrefix(
            this.result._source.path,
            this.webBaseUrl
          );
          break;
      }
    }
  },
  mounted() {
    if (this.result._source) {
      this.preprocessResultCategory();
    }
  }
};
</script>

<style module lang="scss">
@import "./ResultTeaser.scss";
</style>
